import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { MailCheck, Check } from "lucide-react";

export default function AdminNotifications() {
  const [history, setHistory] = useState([]);
  const [openDetail, setOpenDetail] = useState(null);
  useEffect(() => { api.get("/notifications").then((r) => setHistory(r.data)).catch(() => {}); }, []);

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-5" data-testid="admin-notifications">
      <h4 className="flex items-center gap-2 font-display font-bold text-slate-900"><MailCheck className="h-5 w-5 text-amber-600" /> Email notification log</h4>
      <p className="text-xs text-slate-400">Every notification sent across the portal, with delivery and open receipts. Opens are tracked when an SMME's email app loads images.</p>
      <div className="mt-4 space-y-3">
        {history.length === 0 && <p className="rounded-lg border border-dashed border-slate-300 py-10 text-center text-slate-500" data-testid="admin-no-history">No notifications sent yet.</p>}
        {history.map((n) => (
          <div key={n.id} className="rounded-xl border border-slate-200 p-4" data-testid={`admin-history-${n.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <h5 className="font-semibold text-slate-900">{n.subject}</h5>
                <p className="mt-0.5 text-xs text-slate-400">{n.sender || "—"} · {new Date(n.created_at).toLocaleString()}</p>
              </div>
              <div className="flex flex-wrap items-center gap-2 text-xs">
                <span className="rounded-full bg-emerald-100 px-2.5 py-1 font-semibold text-emerald-800" data-testid={`admin-history-received-${n.id}`}>{n.sent_count} received</span>
                <span className="rounded-full bg-indigo-100 px-2.5 py-1 font-semibold text-indigo-800" data-testid={`admin-history-opened-${n.id}`}>{n.opened_count} opened</span>
                {n.sent_count < n.total_count && <span className="rounded-full bg-red-100 px-2.5 py-1 font-semibold text-red-800">{n.total_count - n.sent_count} failed</span>}
                <Button size="sm" variant="outline" onClick={() => setOpenDetail(openDetail === n.id ? null : n.id)} data-testid={`admin-history-toggle-${n.id}`}>{openDetail === n.id ? "Hide" : "Details"}</Button>
              </div>
            </div>
            {openDetail === n.id && (
              <div className="mt-3 overflow-hidden rounded-lg border border-slate-100">
                <table className="w-full text-sm">
                  <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
                    <tr><th className="px-4 py-2">SMME</th><th className="px-4 py-2">Email</th><th className="px-4 py-2">Received</th><th className="px-4 py-2">Opened</th></tr>
                  </thead>
                  <tbody className="divide-y divide-slate-100">
                    {(n.recipients || []).map((r) => (
                      <tr key={r.supplier_id} data-testid={`admin-history-recipient-${n.id}-${r.supplier_id}`}>
                        <td className="px-4 py-2 font-medium text-slate-800">{r.company_name}</td>
                        <td className="px-4 py-2 text-slate-500">{r.email}</td>
                        <td className="px-4 py-2">{r.status === "sent" ? <span className="inline-flex items-center gap-1 text-emerald-700"><Check className="h-3.5 w-3.5" /> Yes</span> : <span className="text-red-600">Failed</span>}</td>
                        <td className="px-4 py-2">{r.opened ? <span className="inline-flex items-center gap-1 text-indigo-700"><MailCheck className="h-3.5 w-3.5" /> {new Date(r.opened_at).toLocaleDateString()}</span> : <span className="text-slate-400">—</span>}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
